import { render } from "./table-pra_pelaksanaan_instruktur.vue?vue&type=template&id=a201da88"
import script from "./table-pra_pelaksanaan_instruktur.vue?vue&type=script&lang=js"
export * from "./table-pra_pelaksanaan_instruktur.vue?vue&type=script&lang=js"

import "./table-pra_pelaksanaan_instruktur.vue?vue&type=style&index=0&id=a201da88&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__